import React, { useContext } from 'react';
import Faq from './Faq';
import ConfigContext from '../../../contexts/ConfigContext';

const getBurgerFaqQuestions = (cityName, siteTitle, vehicleType) => [
  {
    question: `How much does burger food ${vehicleType} catering cost in ${cityName}?`,
    answer: `Burger food ${vehicleType} catering costs in ${cityName} depend on the number of guests, menu selections, and service length. Smaller private events may start at a few hundred dollars, while larger corporate events, weddings, and festivals typically scale higher. ${siteTitle} allows you to compare real quotes from burger food ${vehicleType}s so you can find high-quality catering that fits your budget, with clear pricing and no hidden fees.`
  },
  {
    question: `What types of burgers can a burger food ${vehicleType} serve at my event?`,
    answer: `Burger food ${vehicleType}s offer a wide range of options, including classic beef cheeseburgers, wagyu burgers, chicken sandwiches, smash burgers, and plant-based or vegetarian burgers. Many vendors also offer house-made sauces, gourmet toppings, artisan buns, and customizable burger bars, making it easy to tailor the menu to your event.`
  },
  {
    question: `Are burger food ${vehicleType}s a good choice for corporate events and large groups?`,
    answer: `Yes. Burger food ${vehicleType}s are one of the most popular catering options for corporate lunches, employee appreciation events, and large gatherings. Burgers are fast to serve, familiar, and crowd-pleasing, making them ideal for events with diverse tastes and tight schedules. ${siteTitle} works with experienced burger ${vehicleType}s that regularly serve corporate campuses and high-volume events.`
  },
  {
    question: `Can burger food ${vehicleType}s accommodate vegetarian, vegan, or gluten-free diets?`,
    answer: `Most burger food ${vehicleType}s offer vegetarian and plant-based burgers, and many can provide gluten-free buns or lettuce-wrapped options. When submitting your catering request, you can note any dietary preferences or allergies, and we'll match you with burger food ${vehicleType}s that can accommodate your guests' needs.`
  },
  {
    question: `How far in advance should I book a burger food ${vehicleType} for catering?`,
    answer: `For best availability, we recommend booking a burger food ${vehicleType} 3–6 weeks in advance, especially for summer events, weddings, and corporate catering. However, last-minute bookings may be possible depending on availability. Submitting your request early gives you more menu options and scheduling flexibility.`
  }
];

function BurgerFaq() {
  const { city_name, site_title, vehicle_type } = useContext(ConfigContext);
  const vehicleType = vehicle_type.toLowerCase();

  const questions = getBurgerFaqQuestions(city_name, site_title, vehicleType);

  return (
    <Faq questions={questions} />
  );
}

export default BurgerFaq;
